import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React, { Suspense, lazy } from "react";

/* ================= LAZY IMPORTS ================= */

const Login = lazy(() => import("./pages/Login"));
const Dashboard = lazy(() => import("./pages/Dashboard"));

const Overview = lazy(() => import("./pages/Overview"));
const ClassesOverview = lazy(() => import("./pages/classes/ClassesOverview"));
const ClassWorkspace = lazy(() => import("./pages/classes/ClassesWorkspace"));

const Students = lazy(() => import("./pages/Students"));
const Teachers = lazy(() => import("./pages/Teachers"));
const Attendance = lazy(() => import("./pages/Attendance"));
const Academics = lazy(() => import("./pages/Academics"));
const Announcements = lazy(() => import("./pages/Announcements"));
const Connections = lazy(() => import("./pages/Connections"));
const Leaderboard = lazy(() => import("./pages/Leaderboard"));
const Payroll = lazy(() => import("./pages/Payroll"));
const Finance = lazy(() => import("./pages/Finance"));
const Expenses = lazy(() => import("./pages/Expenses"));
const FeedbackList = lazy(() => import("./pages/FeedbackList"));
const SupportPage = lazy(() => import("./pages/SupportPage"));
const Fees = lazy(() => import("./modules/fees/FeesModule"));

const StudentProfile = lazy(() =>
  import("./modules/student-profile/tabs/StudentProfile")
);

const TeacherProfile = lazy(() =>
  import("./modules/teacher-profile/TeacherProfile")
);

/* ================= EDUCATION LOADER ================= */

function EducationLoader() {
  return (
    <div style={styles.loaderWrapper}>
      <div style={styles.loaderCard}>
        <div style={styles.eduIcon}>🎓</div>
        <h2 style={styles.eduTitle}>Preparing Your School</h2>
        <p style={styles.eduSubtitle}>
          Organizing classes, teachers & students...
        </p>
      </div>
    </div>
  );
}

/* ================= APP ================= */

function App() {
  const schoolId = localStorage.getItem("schoolId");

  return (
    <BrowserRouter>
      <Suspense fallback={<EducationLoader />}>
        <Routes>

          {/* LOGIN */}
          <Route path="/" element={<Login />} />

          {/* DASHBOARD LAYOUT */}
          <Route element={<Dashboard />}>

            <Route path="/dashboard" element={<Overview schoolId={schoolId} />} />

            <Route path="/classes" element={<ClassesOverview schoolId={schoolId} />} />
            <Route path="/classes/:classId" element={<ClassWorkspace schoolId={schoolId} />} />

            <Route path="/students" element={<Students schoolId={schoolId} />} />
            <Route path="/students/:studentId" element={<StudentProfile />} />

            <Route path="/teachers" element={<Teachers schoolId={schoolId} />} />
            <Route path="/teachers/:teacherId" element={<TeacherProfile />} />

            <Route path="/attendance" element={<Attendance schoolId={schoolId} />} />

            <Route path="/academics" element={<Academics schoolId={schoolId} />} />

            <Route path="/announcements" element={<Announcements schoolId={schoolId} />} />

            <Route path="/connections" element={<Connections schoolId={schoolId} />} />

            <Route path="/leaderboard" element={<Leaderboard admin={{ schoolId }} />} />

            <Route path="/finance" element={<Finance schoolId={schoolId} />} />

            <Route path="/payroll" element={<Payroll schoolId={schoolId} />} />

            <Route path="/expenses" element={<Expenses schoolId={schoolId} />} />

            <Route path="/feedback" element={<FeedbackList schoolId={schoolId} />} />

            <Route path="/support" element={<SupportPage schoolId={schoolId} />} />

            <Route path="/fees/*" element={<Fees schoolId={schoolId} />} />

          </Route>

          {/* FALLBACK */}
          <Route path="*" element={<Navigate to="/" />} />

        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;

/* ================= STYLES ================= */

const styles = {

  loaderWrapper: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#0f172a",
  },

  loaderCard: {
    textAlign: "center",
    padding: "50px 60px",
    borderRadius: "20px",
    background: "rgba(255,255,255,0.05)",
    backdropFilter: "blur(20px)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
    border: "1px solid rgba(255,255,255,0.08)",
  },

  eduWrap: {
    textAlign: "center",
  },

  eduIcon: {
    fontSize: "70px",
    animation: "bounce 1.5s infinite",
  },

  eduTitle: {
    color: "#fff",
    fontSize: "22px",
    fontWeight: "700",
    marginTop: "15px",
  },

  eduSubtitle: {
    color: "#9ca3af",
    marginTop: "6px",
  },

};